import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SelectedIndicator = (props) => {
  const { selected = false } = props;

  return (
    <div
      className={classNames(
        'border-radius-level-3',
        'display-block',
        'position-relative',
        {
          'border-blue-6': selected,
          'border-grey-7': !selected,
        },
      )}
      style={{
        width: '20px',
        height: '20px',
        borderWidth: selected ? '2px' : '1px',
      }}
    >
      <span
        className={classNames(
          'background-blue-6',
          'display-block',
          'position-absolute',
          'border-radius-level-3',
          {
            'display-none': !selected,
          },
        )}
        style={{
          width: '10px',
          height: '10px',
          top: '50%',
          left: '50%',
          transform: 'translate3d(-50%, -50%, 0)',
        }}
      />
    </div>
  );
};

SelectedIndicator.propTypes = {
  selected: PropTypes.bool,
};

export default SelectedIndicator;
